import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';

import PbxContext from '../../context/PbxContext';

import { accessLocalStorage, getContatById, valuesAnalyze, changeViewForms, createPhone, updateContact, deletePhone, deleteContact, updatePhone, clickToCall } from '../../services';

import Loading from '../../components/Loading/LoadingModule';
import PhoneCard from './PhoneListCard';
import InputSetPhone from './PhoneCreate';
import InputEditPhone from './PhoneEdit';

import '../../libs/bulma.min.css';
import './ContactsEdit.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneSquare, faSave, faArrowLeft, faTrash } from '@fortawesome/free-solid-svg-icons';

function UpdateCreate() {
  const getItensStateGlobal = useContext(PbxContext);
  const { setItemsSelectedToEdit, toggleIsHidden, toggleIsChangeFormElements, itemsSelectedToEdit, } = getItensStateGlobal;

  let url = window.location.href;
  url = url.split('/')[2];

  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [values, setValues] = useState({});
  const [validate, setValidate] = useState({});
  const [ph, setPh] = useState([]);
  const [disable, setDisable] = useState(true);
  const [phoneModify, setPhoneModify] = useState({});
  const [inputPhone, setInputPhone] = useState({});
  const [idModPhone, setIidModPhone] = useState({});

  const { changeBorderImputToRedOrNormal, changeVisibityMessages} = changeViewForms;

  const validateUserLogged = useCallback(async () => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    const { user: { role } } = dataUser;
    if (!dataUser) return history.push('/');
    // if (dataUser && role !== 'root') return history.push('/home');
    const contactFetch = await getContatById({ id: itemsSelectedToEdit });
    if(itemsSelectedToEdit.length <= 0) return history.push('/agenda/lista');
    if(contactFetch === undefined) setLoading(true);
    if(contactFetch['phones'].length > 0) setPh(contactFetch['phones']);
    setValues(contactFetch);
    return setLoading(false);
  }, []);

  const changeScreen = (check, name) => {
    changeBorderImputToRedOrNormal(check, name);
    changeVisibityMessages(check, `${name}-invalid-data`);
  };

  const handleChangeDataAnalyze = (name, value) => {
    const { checkNumber, isTripleChar } = valuesAnalyze;

    if(name === 'cnpj' || name === 'numberphone' || name === 'editnumberphone') {
      let checkValueIsNumber = checkNumber(value);
      if(name === 'qtt' && value > 1000) checkValueIsNumber = false;
      changeScreen(checkValueIsNumber, name);
      return checkValueIsNumber;
    };

    if(name === 'password') {
      const passwordIsValid = checkPassword(value);
      changeScreen(passwordIsValid, name);
      return passwordIsValid;
    }

    if(name === 'company' || name === 'addr') {
      const checkValueIsCharacters = isTripleChar(value);
      changeScreen(checkValueIsCharacters, name);
      return checkValueIsCharacters;
    }
  };

  const handleChangeValues = (item) => {
    const { name, value } = item;

    const itemStatus = handleChangeDataAnalyze(name, value);
    setValidate((prevState) => prevState, validate[name] = itemStatus === undefined  ? true : itemStatus);
    setValues((prevState) => prevState, values[name] = value )
    if(Object.keys(validate).length >= 5) Object.values(validate).includes(false) ? setDisable(true) : setDisable(false);
    return;
  };

  const insertNumberPhone = () => {
    changeVisibityMessages(true, 'buttons-edit-contact');
    changeVisibityMessages(true, 'list-phones');
    changeVisibityMessages(false, 'input-phone');
  };

  const handleChangeInput = (item) => {
    const { name, value } = item;
    const itemStatus = handleChangeDataAnalyze(name, value);
    setInputPhone({ number: Number(value), contactid: values['idcont'] })
  };

  const handleChangeInputPhoneEdit = (item, idPhone) => {
    const { name, value } = item;
    const itemStatus = handleChangeDataAnalyze(name, value);
    setPhoneModify({ phone: Number(value), id: idModPhone })
  };

  const saveNewPhone = async () => {
    try {
      const newPhone = await createPhone(inputPhone);
      setItemsSelectedToEdit([values['idcont']]);
      await validateUserLogged();
  
      changeVisibityMessages(false, 'buttons-edit-contact');
      changeVisibityMessages(false, 'list-phones');
      changeVisibityMessages(true, 'input-phone');
      document.getElementById('numberphone').value='';
      setInputPhone({})
    } catch (error) {
      console.log(error)
    }
  };

  const cancelCreatePhone = async () => {
    try {
      changeVisibityMessages(false, 'buttons-edit-contact');
      changeVisibityMessages(false, 'list-phones');
      changeVisibityMessages(true, 'input-phone');
      document.getElementById('numberphone').value='';
      setInputPhone({})
    } catch (error) {
      console.log(error)
    }
  };

  const saveEditedPhone = async () => {
    const newPhone = await updatePhone(phoneModify);
    setItemsSelectedToEdit(phoneModify);
    await validateUserLogged();

    changeVisibityMessages(false, 'buttons-edit-contact');
    changeVisibityMessages(false, 'list-phones');
    changeVisibityMessages(true, 'input-edit-phone');
  };

  const cancelEditedPhone = async () => {
    try {
      changeVisibityMessages(false, 'buttons-edit-contact');
      changeVisibityMessages(false, 'list-phones');
      changeVisibityMessages(true, 'input-edit-phone');
    } catch (error) {
      console.log(error)
    }
  };

  const handleClickDelete = async () => {
    try {
      const sendDeleteContact = await deleteContact({ id: values['idcont'] });
      toggleIsHidden('#update-form');
      // toggleIsHidden('#buttons-edit-contact');
      toggleIsHidden('#alert-confirm-contact-delete');
      toggleIsHidden('#success-deleted-contacts');
      toggleIsHidden('#list-phones');
      setTimeout(() => {
        return history.push('/agenda/lista');
      }, 3000);
    } catch (error) {
      toggleIsHidden('#update-form');
      toggleIsHidden('#buttons-edit-contact');
      toggleIsHidden('#alert-confirm-contact-delete');
      toggleIsHidden('#error-delete-contact');
      toggleIsHidden('#list-phones');
      setTimeout(() => {
        return history.push('/home');
      }, 3000);
    }
  };

  const handleClickDeletePhone = async (data) => {
    const { value, phone } = data;
    try {
      const sendDeleteContact = await deletePhone({ id: Number(value) });
      if(values['phones'].length === 1) history.push('/agenda/lista');
      setItemsSelectedToEdit([values['idcont']]);
      await validateUserLogged();
    } catch (error) {
      changeVisibityMessages(false, `delete-phone-link-${value}`);
      changeVisibityMessages(true, `delete-phone-confirm-${value}`);
    }

  };
  
  const sendDataContactUpdate = async () => {
    const updateContactSend = await updateContact({
      id: values['idcont'],
      company: values['compname'],
      fantasy: values['namefantasy'],
      addr: values['addr'],
      cnpj: Number(values['cnpj']),
      email: values['mail'],
      alias: values['alias'],
      comment: values['comm'],
    });

    const result = Object.keys(updateContactSend).length > 0 ? true : false;
    if(result) {
      setLoading(false);
      setItemsSelectedToEdit([values['idcont']]);
      await validateUserLogged();
      changeVisibityMessages(false, 'success-updeted-contacts');
      setTimeout(() => {
        return changeVisibityMessages(true, 'success-updeted-contacts');
      }, 3000);
    };
    return;
  };

  
  const handleClickToCall = async (phone) => {
    let phoneFull = phone;
    if(phoneFull.length === 10 || phoneFull.length === 11) phoneFull = `0${phone}`;
    const { user } = await accessLocalStorage.getUserLocalStorage();
    const myEndpoint = { 
      name: `${values['namefantasy']}`,
      dest: phoneFull,
      exten: user.endpoint
    }
    console.log(myEndpoint);
    const result = await clickToCall(myEndpoint);
  };

  useEffect(() => {
    let cancel = false;
    validateUserLogged();

    return () => {
      cancel = true
    };
  }, [validateUserLogged]);

  return (
    <div className="contacts-edit-container">
      {loading ? (
        <Loading />
      ) : (
        <>
          <div className="contacts-edit-header">
            <div className="contacts-edit-title-wrapper">
              <svg className="contacts-edit-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
              </svg>
              <div>
                <h1 className="contacts-edit-title">Editar Contato</h1>
                <p className="contacts-edit-subtitle">Atualize os dados do contato</p>
              </div>
            </div>
            <Link to="/agenda/lista" className="btn-back">
              <FontAwesomeIcon icon={faArrowLeft} />
              Voltar
            </Link>
          </div>
          <div className="alerts-section">
            <article id="alert-confirm-contact-delete" name="alert-confirm-contact-delete" className="alert-message alert-danger is-hidden">
              <div className="alert-header">
                <p>Atenção!</p>
                <button className="alert-close" aria-label="delete" onClick={ () => toggleIsHidden('#alert-confirm-contact-delete') }></button>
              </div>
              <div className="alert-body">
                Tem certeza que quer deletar o contato?
              </div>
              <div className="alert-actions">
                <button className="btn-alert btn-danger" type="submit" onClick={ () => handleClickDelete() }>
                  <FontAwesomeIcon icon={ faTrash } fixedWidth />
                  <span>Confirmar</span>
                </button>
                <button className="btn-alert btn-info" type="submit" onClick={ () => {
                  toggleIsHidden('#alert-confirm-contact-delete')
                  toggleIsHidden('#buttons-edit-contact')
                }}>
                  <FontAwesomeIcon icon={ faArrowLeft } fixedWidth />
                  <span>Cancelar</span>
                </button>
              </div>
            </article>
            <article id="error-delete-contact" name="error-delete-contact" className="alert-message alert-danger is-hidden">
              <div className="alert-header">
                <p>Erro!</p>
                <button className="alert-close" aria-label="delete" onClick={ () => toggleIsHidden('#error-delete-contact') }></button>
              </div>
              <div className="alert-body">
                Não foi possível deletar o contato!
              </div>
            </article>
            <article id="success-deleted-contacts" name="success-deleted-contacts" className="alert-message alert-success is-hidden">
              <div className="alert-header">
                <p>Sucesso!</p>
                <button className="alert-close" aria-label="delete" onClick={ () => toggleIsHidden('#success-deleted-contacts') }></button>
              </div>
              <div className="alert-body">
                Contato deletado com <strong>sucesso</strong>!
              </div>
            </article>
            <article id="success-updeted-contacts" name="success-updeted-contacts" className="alert-message alert-success is-hidden">
              <div className="alert-header">
                <p>Sucesso!</p>
                <button className="alert-close" aria-label="delete" onClick={ () => toggleIsHidden('#success-updeted-contacts') }></button>
              </div>
              <div className="alert-body">
                Contato atualizado com <strong>sucesso</strong>!
              </div>
            </article>
          </div>
          <div className="form-card">
            <form name="update-form" id="update-form" onSubmit={ (e) =>  e.preventDefault() }>
              <div className="form-row">
                <div className="form-field">
                  <label className="form-label">Razão Social</label>
                  <div className="form-control">
                    <input className="form-input" name="compname" type="text" defaultValue={ values['compname']} onChange={(e) => handleChangeValues(e.target)} placeholder="Razão Social" />
                    <p name="compname-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
                  </div>
                </div>
                <div className="form-field">
                  <label className="form-label">Nome Fantasia</label>
                  <div className="form-control">
                    <input className="form-input" name="namefantasy" type="text" defaultValue={ values['namefantasy']} onChange={(e) => handleChangeValues(e.target)} placeholder="Nome Fantasia" />
                    <p name="namefantasy-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
                  </div>
                </div>
                <div className="form-field">
                  <label className="form-label">Endereço</label>
                  <div className="form-control">
                    <input className="form-input" name="addr" type="text" defaultValue={ values['addr']} onChange={(e) => handleChangeValues(e.target)} placeholder="Rua Abc, 1000"/>
                    <p name="addr-invalid-data" className='form-error is-hidden'>Verifique o tamanho e se existem caracteres inválidos!</p>
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="form-field">
                  <label className="form-label">CNPJ/CPF</label>
                  <div className="form-control">
                    <input className="form-input" name="cnpj" type="text" defaultValue={ values['cnpj']} onChange={(e) => handleChangeValues(e.target)} placeholder="Apenas números"/>
                    <p name="cnpj-invalid-data" className='form-error is-hidden'>Verifique o tamanho e se existem caracteres inválidos!</p>
                  </div>
                </div>
                <div className="form-field">
                  <label className="form-label">E-mail</label>
                  <div className="form-control">
                    <input className="form-input" name="mail" type="text" defaultValue={ values['mail']} onChange={(e) => handleChangeValues(e.target)} placeholder="empresa@email.com.br"/>
                    <p name="mail-invalid-data" className='form-error is-hidden'>Verifique o tamanho e se existem caracteres inválidos!</p>
                  </div>
                </div>
                <div className="form-field">
                  <label className="form-label">Apelido</label>
                  <div className="form-control">
                    <input className="form-input" name="alias" type="text" defaultValue={ values['alias']} onChange={(e) => handleChangeValues(e.target)} placeholder="Apelido"/>
                    <p name="alias-invalid-data" className='form-error is-hidden'>Verifique o tamanho e se existem caracteres inválidos!</p>
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="form-field form-field-full">
                  <label className="form-label">Comentários</label>
                  <div className="form-control">
                    <input className="form-input" name="comm" type="text" defaultValue={ values['comm'] !== 'undefined' ? values['comm'] : ''} onChange={(e) => handleChangeValues(e.target)} placeholder="Apenas texto e números. (-_,)"/>
                    <p name="comm-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
                  </div>
                </div>
              </div>
            </form>
            
            <div id="buttons-edit-contact" name="buttons-edit-contact" className="form-actions-edit">
              <button className="btn-edit-action btn-save-edit" type="submit" onClick={() => sendDataContactUpdate() }>
                <FontAwesomeIcon icon={ faSave } fixedWidth />
                <span>Salvar Alterações</span>
              </button>
              <button name="insert-phone" className="btn-edit-action btn-add-phone" type="submit" onClick={() => insertNumberPhone()}>
                <FontAwesomeIcon icon={ faPhoneSquare } fixedWidth />
                <span>Adicionar Telefone</span>
              </button>
              <button name="delete-contact" className="btn-edit-action btn-delete-contact" type="submit" onClick={ () => {
                toggleIsHidden('#alert-confirm-contact-delete')
                toggleIsHidden('#buttons-edit-contact')
              } }>
                <FontAwesomeIcon icon={ faTrash } fixedWidth />
                <span>Deletar Contato</span>
              </button>
            </div>
          </div>
          <div name="input-phone" className="input-phone-section is-hidden">
            <InputSetPhone handleChangeinput={ handleChangeInput } save={ saveNewPhone } cancel={ cancelCreatePhone }/>
          </div>
          <div name="input-edit-phone" id="input-edit-phone" className="input-phone-section is-hidden">
            <InputEditPhone handleChangeInput={ handleChangeInputPhoneEdit } save={ saveEditedPhone } phoneModify={ phoneModify } setPhoneModify={ setPhoneModify } cancel={ cancelEditedPhone }/>
          </div>
          <div id="list-phones" name="list-phones" className="phones-grid">
            { ph.map((phone) => <PhoneCard key={phone.phonenumber} phones={ phone } changeVisibityMessages={ changeVisibityMessages } handleClickToCall={ handleClickToCall } setPhoneModify={ setPhoneModify } setIidModPhone={ setIidModPhone } del={ handleClickDeletePhone }/>) }
          </div>
        </>
      )}
    </div>
  );
}

export default UpdateCreate;
